import Sidebar from "@/components/Sidebar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-white">
      <Sidebar />
      <main className="ml-[280px] min-h-screen p-10 2xl:p-14" data-testid="main-content">
        <div className="max-w-[1240px]">{children}</div>
      </main>
    </div>
  );
}
